import Alert from "../../ui/alert"
import { colors } from "../../../utilities/colors"

export default function AuditUnitWarnings({ warnings }) {
  return (
    <>
      {warnings.length > 0 &&
        <Alert title={warnings.join(' - ')} bgColor={colors.fpxRed} />
      }
    </>
  )
}